import React from "react";
import { InfoCardWithCircle } from "../../../../../components";

const InfoCardWithCircleList = () => {
  const applicantDetailData = [
    { Applicants: "02", Submissions: "0", Pipeline: "02" },
  ];
  return (
    <div className="flex flex-col gap-5 mt-4">
      <InfoCardWithCircle data={applicantDetailData} size="xs" />
      <InfoCardWithCircle data={applicantDetailData} size="sm" />
      <InfoCardWithCircle data={applicantDetailData} size="lg" />
      <InfoCardWithCircle data={applicantDetailData} size="xl" />
    </div>
  );
};

export default InfoCardWithCircleList;
